function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.5C6.71443 14.5 5.45772 14.1188 4.3888 13.4046C3.31988 12.6903 2.48676 11.6752 1.99479 10.4874C1.50282 9.29972 1.3741 7.99279 1.6249 6.73191C1.8757 5.47104 2.49477 4.31285 3.40381 3.40381C4.31285 2.49476 5.47104 1.8757 6.73192 1.6249C7.99279 1.37409 9.29973 1.50281 10.4874 1.99478C11.6752 2.48675 12.6903 3.31987 13.4046 4.38879C14.1188 5.45771 14.5 6.71442 14.5 8C14.4979 9.72326 13.8124 11.3753 12.5939 12.5939C11.3753 13.8124 9.72326 14.4979 8 14.5Z",
  fill: "#8899AA"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 11L10 8L7 5",
  stroke: "#8899AA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgArrowDetails = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-details.9010892f.svg";
export { ForwardRef as ReactComponent };